import React from 'react';
import Icon from '../../../components/AppIcon';

const QuizHeader = ({ quizTitle, currentQuestion, totalQuestions, timeEstimate, onExit }) => {
  const progress = (currentQuestion / totalQuestions) * 100;

  return (
    <div className="bg-card border-b border-border">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 lg:px-8 py-4 md:py-6">
        <div className="flex flex-col gap-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10">
                <Icon name="ClipboardList" size={20} color="var(--color-primary)" />
              </div>
              <div>
                <h1 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground">{quizTitle}</h1>
                <p className="text-xs md:text-sm text-muted-foreground caption">
                  Temps estimé: {timeEstimate} minutes
                </p>
              </div>
            </div>
            <button
              onClick={onExit}
              className="flex items-center gap-2 px-3 py-2 md:px-4 md:py-2 rounded-lg bg-muted hover:bg-muted/80 transition-smooth"
              aria-label="Quitter le quiz"
            >
              <Icon name="X" size={18} />
              <span className="hidden md:inline text-sm font-medium">Quitter</span>
            </button>
          </div>

          <div className="flex items-center gap-4">
            <div className="flex-1">
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs md:text-sm font-medium text-foreground">
                  Question {currentQuestion} sur {totalQuestions}
                </span>
                <span className="text-xs md:text-sm font-medium text-primary">
                  {Math.round(progress)}%
                </span>
              </div>
              <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-primary to-secondary transition-all duration-500"
                  style={{ width: `${progress}%` }}
                  role="progressbar"
                  aria-valuenow={progress}
                  aria-valuemin="0"
                  aria-valuemax="100"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuizHeader;